<ng-container *ngIf="customErrorMessage && customErrorMessage.length > 0">
  <div *ngFor="let error of customErrorMessage; let i = index">
    <ng-container *ngIf="error.userMessage">
      <p
        [ngClass]="{
          'error-text': !dormancyCheck,
          'm-b-sm': !dormancyCheck,
          'error-container': dormancyCheck,
          'text-start': dormancyCheck,
          'f-s-14': errorMessageSize,
        }"
        id="errorMessage{{ i }}"
      >
        <i
          *ngIf="!dormancyCheck"
          class="fa fa-exclamation-circle def error-icon nofloat"
          (click)="showDetails[i] = !showDetails[i]"
        ></i>
        <i *ngIf="dormancyCheck" class="img-icon exclamation-triangle m-r-xs"></i>
        <span [innerHTML]="error?.userMessage"></span>
      </p>
    </ng-container>
    <div *ngIf="showDetails[i] && !isProdEnabled" class="radio-check-spacer break-words m-t-xs">
      <p class="legal"><strong>Status Code:</strong> {{ error?.code }}</p>
      <p class="legal"><strong>System Message:</strong> {{ error?.systemMessage }}</p>
      <p class="legal"><strong>User Message:</strong> {{ error?.userMessage }}</p>
      <p class="legal"><strong>Api Number:</strong> {{ error?.apiNumber }}</p>
    </div>
  </div>
</ng-container>
<div *ngIf="errorText">
  <p
    [ngClass]="{
      'error-text': !dormancyCheck,
      'error-container': dormancyCheck,
      'text-start': dormancyCheck,
    }"
    id="errorMessage0"
  >
    <i *ngIf="!dormancyCheck" class="fa fa-exclamation-circle def error-icon nofloat"></i>
    <i *ngIf="dormancyCheck" class="img-icon exclamation-triangle m-r-xs"></i>
    {{ errorText }}<ng-content></ng-content>
  </p>
</div>
<div *ngIf="errorFormater">
  <div
    [ngClass]="{
      'error-text': !dormancyCheck,
      'error-container': dormancyCheck,
      'text-start': dormancyCheck,
    }"
    id="errorMessage0"
  >
    <i *ngIf="!dormancyCheck" class="fa fa-exclamation-circle def error-icon nofloat"></i>
    <i *ngIf="dormancyCheck" class="img-icon exclamation-triangle m-r-xs"></i>
    <div *ngIf="errorFormater?.primaryMessage">
      {{ errorFormater?.primaryMessage }}
      <ng-container
        *ngIf="errorFormater?.secondaryMessage && errorFormater?.secondaryMessage.length"
      >
        <div class="pt-1" *ngFor="let err of errorFormater?.secondaryMessage">
          <b>{{ err }}</b>
        </div>
      </ng-container>
    </div>
  </div>
</div>
